import React from "react";
import logo from "../../../assets/images/navbar_logo.png";

interface AccessDeniedScreenProps {
  message: string;
  onSignOut: () => void;
}

/**
 * Shown when the backend confirms the user is not onboarded or has been deactivated.
 * Displayed in place of the full app shell (no router context needed).
 */
export const AccessDeniedScreen: React.FC<AccessDeniedScreenProps> = ({
  message,
  onSignOut,
}) => (
  <div className="flex flex-col h-screen">
    <header className="flex items-center justify-between h-14 w-full px-4 text-[var(--text-primary)] bg-[var(--bg-surface)] sticky top-0 z-50">
      <div className="flex items-center gap-2">
        <img src={logo} alt="Logo" className="h-8 w-auto" />
        <span className="text-xl">CLOUD NOTIFICATION CENTER</span>
      </div>
      <button
        onClick={onSignOut}
        className="text-sm text-[var(--text-primary)]/70 hover:text-[var(--text-primary)] transition"
      >
        Sign out
      </button>
    </header>

    <main className="flex-1 flex flex-col items-center justify-center gap-3 text-center px-6">
      <i className="pi pi-lock text-5xl text-[var(--status-error)]" />
      <h2 className="text-xl font-semibold text-[var(--text-primary)]">No access</h2>
      <p className="text-[var(--text-tertiary)] max-w-sm">
        {message || "Your account is not registered or has been deactivated."}
      </p>
      <p className="text-[var(--text-tertiary)] text-sm">
        Please contact your administrator to get access.
      </p>
      <button
        onClick={onSignOut}
        className="mt-4 px-5 py-2 rounded-md border border-[var(--border-default)] text-sm text-[var(--text-secondary)] hover:bg-[var(--bg-elevated)] transition"
      >
        Sign out
      </button>
    </main>
  </div>
);
